import { PessoaCatalogo } from '../../model/geral/pessoaCatalogo';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { AutoRegisterService } from '../generics/servicesRegistry';

@Injectable({
  providedIn: 'root'
})
@AutoRegisterService()
export class PessoaCatalogoService extends GenericService<PessoaCatalogo> {
  constructor(http: HttpClient) {
    super(http);
    super.initResource('pessoacatalogo');
  }
}
